export const START_PATH = '/start'
export const NO_STAGE_PATH = '/no-construction-site'
export const ORG_PROJECTS_PATH = '/settings/organization/projects'
export const ACCOUNT_PATH = '/settings/account'

export const stageDashboardPath = (stageId: number | string) =>
  `/project_stages/${stageId}/dashboard`
